// extracted by mini-css-extract-plugin
module.exports = {"form":"addHospitalModal_form__24vfV","form-control":"addHospitalModal_form-control__1gPEF","title":"addHospitalModal_title__LCeWv"};